import { Routes } from '@angular/router';
import { authRoute } from './auth/auth.routes';
import { AccessDeniedComponent } from './common/access-denied/access-denied.component';
import { privateRoute } from './private/private.routes';

export const routes: Routes = [
  authRoute,
  privateRoute,
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'error',
    loadComponent: () => import('./common/error/error.component').then((c) => c.ErrorPageComponent),
    children: [
      {
        path: ':errorType',
        loadComponent: () =>
          import('./common/error/error-type/error-type.component').then(
            (c) => c.ErrorTypePageComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'private/landing',
  },
];
